module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_about_ckd-780e8e79bf18320f6ad6b20a034fdfe8.png";